// Scoped console logger. Usage and conventions: .claude/rules/vue/logging.md.
//
// No app dependencies on purpose (only the sibling redactor.js, imported
// relatively): shared.js imports this and is bundled standalone into the kiosk
// IIFE, which must not pull in LogRocket, the store, or other app code.
//
// DevTools links each line to the real call site, not this file, because the
// file is ignore-listed in its sourcemap (loggerSourcemap in vite.config.mjs).

import { Redactor } from './redactor.js'

// Chrome-only %c styling (the app only supports Chrome). One mid-tone color
// for every scope, readable on both DevTools themes.
const PREFIX_STYLE = 'color: hsl(210, 70%, 50%); font-weight: bold'

// LogRocket's console capture is off (see initLogRocket). Lines reach replays
// through this instead, with a plain prefix and the same redacted args.
let logRocket = null

export function setReplaySink(sink) {
  logRocket = sink
}

const redactor = new Redactor()

class Logger {
  constructor(scope) {
    this.prefix = `[${scope}]`
  }

  debug(...args) { this.write('debug', args) }
  info(...args)  { this.write('info', args) }
  warn(...args)  { this.write('warn', args) }
  error(...args) { this.write('error', args) }

  write(level, args) {
    const safeArgs = args.map((arg) => redactor.sanitize(arg))

    console[level](`%c${this.prefix}`, PREFIX_STYLE, ...safeArgs)

    if (logRocket) {
      logRocket[level](this.prefix, ...safeArgs)
    }
  }
}

export function getLogger(scope) {
  return new Logger(scope)
}

const logger = getLogger('app')

export const LoggerPlugin = {
  install(app) {
    app.config.globalProperties.$log = logger
  }
}

export default logger
